const SET_MAP_BASE_LAYER = "SET_MAP_BASE_LAYER";
const SET_MAP_OVERLAYER = "SET_MAP_OVERLAYER";
const SET_ZOOM = "SET_ZOOM";
const SET_CENTER_MAP = "SET_CENTER_MAP";
const SET_MAP_BOUNDS = "SET_MAP_BOUNDS";
const VIEW_CUSTOM_MAP = "VIEW_CUSTOM_MAP";
const SET_SEARCH_LOCATION = "SET_SEARCH_LOCATION";

const setMapBaseLayerAction = (data) => {
  return {
    type: SET_MAP_BASE_LAYER,
    baseLayer: data,
  };
};

const setMapOverlayerAction = (data) => {
  return {
    type: SET_MAP_OVERLAYER,
    overlayers: data,
  };
};

const setBaselayer = (layer) => {
  return (dispatch) => {
    dispatch(setMapBaseLayerAction(layer));
  };
};

const setOverlayers = (layer) => {
  return (dispatch) => {
    dispatch(setMapOverlayerAction(layer));
  };
};

const setZoomAction = (data) => {
  return {
    type: SET_ZOOM,
    zoom: data,
  };
};

const setMapBoundsAction = (data) => {
  return {
    type: SET_MAP_BOUNDS,
    mapBounds: data,
  };
};

const setZoom = (zoom) => {
  return (dispatch) => {
    dispatch(setZoomAction(zoom));
  };
};

const setCenterMapAction = (data) => {
  return {
    type: SET_CENTER_MAP,
    mapCenter: data,
  };
};

const setMapCenter = (bound) => {
  return (dispatch) => {
    dispatch(setCenterMapAction(bound));
  };
};

const setMapBounds = (bounds) => {

  console.log(bounds)

  return (dispatch) => {
    dispatch(setMapBoundsAction(bounds));
  };
};

const viewCustomMapAction = (isViewCustomMap) => {
  return {
    type: VIEW_CUSTOM_MAP,
    isViewCustomMap,
  };
};

const setSearchLocationAction = (location) => {
  return {
    type: SET_SEARCH_LOCATION,
    location,
  };
};


const viewCustomMap = (isViewCustomMap) => {
  return (dispatch) => {
    dispatch(viewCustomMapAction(isViewCustomMap));
  };
};


const setSearchLocation= (location) => {
  return (dispatch) => {
    dispatch(setSearchLocationAction(location));
  };
};

export {
  setBaselayer,
  SET_MAP_BASE_LAYER,
  setOverlayers,
  SET_MAP_OVERLAYER,
  setZoom,
  SET_ZOOM,
  setMapCenter,
  SET_CENTER_MAP,
  setMapBounds,
  SET_MAP_BOUNDS,
  viewCustomMap,
  VIEW_CUSTOM_MAP,
  setSearchLocation,
  SET_SEARCH_LOCATION,
};
